/**
 * A utility function that creates a promise that resolves after a set amount of time.
 * Mostly intended for simulating promises that do not resolve immediately.
 * @param delay milliseconds to sleep for
 */
const sleep = (delay: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, delay));

export { sleep };
